import type { EventEnvelope } from "@baton/api";
import type { EventType } from "./catalogue.generated.ts";
import type { BatonEvent } from "./types.ts";

/**
 * Whether an envelope is one of the given types, which narrows it to them (2026-10-15). A screen that
 * listens for a type or two in the first load names them here rather than asking the whole catalogue,
 * so the entry carries the types it reads and not the generated list of every type, which the event
 * reducer's chunk holds (`known.ts`).
 */
export function isEventOf<T extends EventType>(envelope: EventEnvelope, ...types: readonly T[]): envelope is Extract<BatonEvent, { readonly type: T }> {
  return (types as readonly string[]).includes(envelope.type);
}
